import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Check, ArrowLeft, Code } from './Icons';
import Footer from './Footer';

const API = () => {
  return (
    <div className="min-h-screen bg-white font-sans selection:bg-zinc-900 selection:text-white overflow-hidden">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-zinc-100 py-4">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-6 h-6 bg-white border-2 border-black rounded-sm flex items-center justify-center">
              <Check className="w-4 h-4 text-black" strokeWidth={3} />
            </div>
            <span className="font-bold text-lg tracking-tight text-zinc-900">GradeMind.ai</span>
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm font-medium text-zinc-600 hover:text-zinc-900 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 min-h-[80vh] flex items-center justify-center">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="mb-8"
          >
            <div className="w-32 h-32 mx-auto bg-zinc-900 rounded-3xl flex items-center justify-center mb-8 shadow-2xl">
              <Code className="w-16 h-16 text-white" strokeWidth={1.5} />
            </div>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter text-zinc-900 mb-6"
          >
            API Coming Soon
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="text-xl md:text-2xl text-zinc-600 leading-relaxed mb-12"
          >
            We're building a powerful API to integrate GradeMind's AI grading capabilities directly into your applications.
          </motion.p>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-zinc-900 mb-12 text-center">Potential Use Cases</h2>
          <div className="space-y-6">
            <div className="bg-white border-2 border-zinc-200 rounded-2xl p-6 hover:border-zinc-900 transition-colors">
              <h3 className="text-xl font-bold text-zinc-900 mb-2">Learning Management Systems</h3>
              <p className="text-zinc-600">Integrate AI grading directly into your LMS platform for seamless assessment workflows.</p>
            </div>
            <div className="bg-white border-2 border-zinc-200 rounded-2xl p-6 hover:border-zinc-900 transition-colors">
              <h3 className="text-xl font-bold text-zinc-900 mb-2">Educational Apps</h3>
              <p className="text-zinc-600">Build educational applications with built-in automated grading capabilities.</p>
            </div>
            <div className="bg-white border-2 border-zinc-200 rounded-2xl p-6 hover:border-zinc-900 transition-colors">
              <h3 className="text-xl font-bold text-zinc-900 mb-2">Custom Workflows</h3>
              <p className="text-zinc-600">Create custom grading workflows tailored to your institution's specific needs.</p>
            </div>
            <div className="bg-white border-2 border-zinc-200 rounded-2xl p-6 hover:border-zinc-900 transition-colors">
              <h3 className="text-xl font-bold text-zinc-900 mb-2">Batch Processing</h3>
              <p className="text-zinc-600">Process large volumes of submissions programmatically for enterprise-scale assessment.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default API;